/**
 * Retrieve Privacy Policy flagged Policy from Consent list
 * @param {VuexState} state
 * @returns {Policy}
 * @TODO harden consumer `hg-opt-out` to be more resilient to `undefined` output
 */
const getCustomerUuid = state => state.customer;

export default { getCustomerUuid };
